// src/extenders/product-shortcode.js
var ShortcodeProduct = class extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.renderPlaceholder();
  }
  connectedCallback() {
    if (this.productHandle)
      this.loadProduct();
  }
  renderPlaceholder() {
    this.innerHTML = '<div class="product-card loading">Loading product...</div>';
  }
  async loadProduct() {
    var _a;
    const query = `
     query getProduct($handle: String!) {
        productByHandle(handle: $handle) {
          id
          title
          handle
          images(first: 1) {
            edges {
              node {
                url
                altText
              }
            }
          }
          metafields(identifiers: [{namespace: "custom", key: "algemeen_summary_list"}]) {
            value
            namespace
            key
          }
        }
      }
    `;
    const variables = { handle: this.productHandle };
    const API_URL = "https://image-skincare-nl.myshopify.com/api/2024-01/graphql.json";
    const API_TOKEN = "392b43fed9bb01a1c6eebb8640f7bec2";
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": API_TOKEN
        },
        body: JSON.stringify({ query, variables })
      });
      const json = await response.json();
      console.log("API Response:", json);
      if (json.errors)
        throw new Error(JSON.stringify(json.errors));
      const product = (_a = json.data) == null ? void 0 : _a.productByHandle;
      if (!product)
        throw new Error("Product not found");
      console.log("Metafield:", product.metafields);
      this.renderProduct(product);
    } catch (error) {
      console.error("ShortcodeProduct Error:", error);
      this.innerHTML = '<div class="product-card error">Product not found.</div>';
    }
  }
  renderProduct(product) {
    var _a, _b, _c;
    const image = ((_b = (_a = product.images) == null ? void 0 : _a.edges[0]) == null ? void 0 : _b.node) || { url: "fallback-image-url.jpg", altText: "Default Image" };
    const handle = product.handle || "default-handle";
    const productSummary = (_c = product.metafields) == null ? void 0 : _c.find((metafield) => metafield.key === "algemeen_summary_list");
    this.innerHTML = `
      <div class="h-full no-underline product-card">
        <a href="/products/${handle}" aria-label="${product.title}">
          <div class="flex relative flex-col h-full bg-main-grayish">
            <div class="overflow-hidden relative w-full aspect-square group">
              <img src="${image.url}" alt="${image.altText || product.title}" class="object-cover w-full h-full">
            </div>
            <div class='flex-1 justify-between px-4 mt-4'>
              <div class='flex flex-col gap-2 h-full'>
                <span class='text-sm text-black line-clamp-2'>
                  ${product.title}
                </span>
                <div class='mt-auto mb-4 text-light-gray product-summary'>
                   ${productSummary ? productSummary.value : ""}
                </div>
              </div>
            </div>

            <div class='px-2 pb-2 mt-auto'>
              <div class='flex justify-end mb-2 pr-2 font-[var(--font-heading-weight)]'>
                <span>

                </span>
              </div>
              <div class='justify-center w-full button button--black group' style="padding: .75rem 1rem">
                <span class='relative'>
                  ${window.variantStrings.view_product}
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    `;
  }
};
customElements.define("shortcode-product", ShortcodeProduct);
document.addEventListener("DOMContentLoaded", () => {
  const pageContent = document.getElementById("page-content");
  pageContent.classList.add("grid", "grid-cols-2", "md:grid-cols-3", "gap-2");
  if (!pageContent)
    return;
  pageContent.innerHTML = pageContent.innerHTML.replace(
    /\[product handle="([\w-]+)"\]/g,
    (_, handle) => `<shortcode-product data-product-handle="${handle}"></shortcode-product>`
  );
});
